import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export const AddButtonBox = ({isSuperAdmin}) => {
    const navigateTo = useNavigate();
    return (
        <div className="add-box">
            <button className="add-button" onClick={() => navigateTo("/addlesson")}>
                <FontAwesomeIcon icon={faPlusCircle} className="add-icon" />
                <span className="add-caption">Create new lesson</span>
            </button>
            <button className="add-button" onClick={() => navigateTo("/addcourse")}>
                <FontAwesomeIcon icon={faPlusCircle} className="add-icon" />
                <span className="add-caption">Create new course</span>
            </button>
            {isSuperAdmin && (
                <button className="add-button" onClick={() => navigateTo("/addcategory")}>
                    <FontAwesomeIcon icon={faPlusCircle} className="add-icon" />
                    <span className="add-caption">Create new category</span>
                </button>
            )}
        </div>
    )
}